module.exports = __webpack_public_path__ + "0dae1871088fb2f95d75919c210ad7d2.svg";